import { combineReducers } from "redux";
import { reducer as notificationsReducer } from "react-notification-system-redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import mainReducer from "./mainReducer";
import pdApiReducer from "./pdApiReducer";
import editReducer from "./editReducer";
import toggleChildReducer from "./toggleChildReducer";
import columnReducer from "./columnReducer";
import ioConfigReducer from "./ioConfigReducer";
import loadingReducer from "./loadingReducer";
import publishingReducer from "./publishingReducer";
import filterReducer from "./filterReducer";
import translationStatusFilterReducer from "./translationStatusFilterReducer";
import licenseGenerationReducer from "./licenseGenerationReducer";
import escalatorDevPackageReducer from "./escalatorDevPackageReducer";
import licenseUploadReducer from "./licenseUploadReducer";

const mainPersistConfig = {
  key: "main",
  storage,
  blacklist: ["fetchingStatus", "activeUser"]
};
const rootReducer = combineReducers({
  main: persistReducer(mainPersistConfig, mainReducer),
  pdApi: pdApiReducer,
  notifications: notificationsReducer,
  editView: editReducer,
  toggleChildView: toggleChildReducer,
  columns: columnReducer,
  ioConfig: ioConfigReducer,
  loadingStatus: loadingReducer,
  publishingStatus: publishingReducer,
  licenseGenerationStatus: licenseGenerationReducer,
  licenseUploadStatus: licenseUploadReducer,
  filterOptions: filterReducer,
  translationStatusFilterOptions: translationStatusFilterReducer,
  escalatorDevPackageStatus: escalatorDevPackageReducer,
});

export default rootReducer;
//Here we export the type of state to strict our selectors to this type State
export type State = ReturnType<typeof rootReducer>;
